// extracted by mini-css-extract-plugin
export default {"navMenuList":"NavMenuList_navMenuList__C9Swm","navMenuItem":"NavMenuList_navMenuItem__ygOYA","boldText":"NavMenuList_boldText__32cR0"};